import { render, staticRenderFns } from "./statisticsManageList.vue?vue&type=template&id=1b9e0aa0&scoped=true"
import script from "./statisticsManageList.vue?vue&type=script&lang=js"
export * from "./statisticsManageList.vue?vue&type=script&lang=js"
import style0 from "./statisticsManageList.vue?vue&type=style&index=0&id=1b9e0aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e0aa0",
  null
  
)

export default component.exports